export const tasksAction = {
  openTaskModal: (state, action) => {
    state.selectedTask = action.payload.selectedTask;
    state.taskModalOpen = action.payload.taskModalOpen;
    state.requestType = action.payload.requestType;
    state.taskModalTitle = action.payload.taskModalTitle;
  },
  setLoading: (state, action) => {
    state.isLoading = action.payload;
  },
  setTableFilters: (state, action) => {
    state.filters = action.payload;
  },
  closeTaskModal: (state) => {
    state.taskModalOpen = false;
  },
  setSelectedTask: (state, action) => {
    state.selectedTask = action.payload;
  },
  setRefetchTasks: (state, action) => {
    state.refetchTasks = action.payload;
  },
  setSelectedRowIds: (state, action) => {
    state.selectedRowIds = action.payload;
  },
  setArchiveModalOpen: (state, action) => {
    state.archiveModalOpen = action.payload;
  },
  setSingleTaskArchive: (state, action) => {
    state.singleTaskArchive = action.payload;
  },
  changeSearch: (state, action) => {
    state.searchText = action.payload;
  },
};
